import type { KpiStatus } from "@playbookai/types";
import type { SparkTone } from "../atoms/Sparkline/Sparkline.js";

/**
 * Map a semantic `KpiStatus` to a Sparkline tone. `none` → `neutral` (muted),
 * never `info` (cyan would misread as "informational", not "no data"). This is
 * a *separate* dictionary from `statusToken` (lib/types), which drives the
 * status dot + label; sparkline stroke/fill speak the Sparkline `tone` palette.
 * Shared by the KPI-backed widget bodies (singleKpi / chart / kpiWatchlist /
 * kpiTable).
 */
const STATUS_TO_SPARK_TONE: Record<KpiStatus, SparkTone> = {
  healthy: "healthy",
  watch: "watch",
  critical: "critical",
  none: "neutral",
};

export function statusToSparkTone(status: KpiStatus): SparkTone {
  return STATUS_TO_SPARK_TONE[status];
}

/**
 * Delta-text colour for the watchlist / table rows: `critical` and `watch` are
 * loud, everything else (incl. `healthy`) is muted — matching the oracle, where
 * a healthy delta is intentionally NOT teal (it would shout on a dense list).
 */
const STATUS_DELTA_CLASS: Record<KpiStatus, string> = {
  critical: "text-pb-red-text",
  watch: "text-pb-amber-text",
  healthy: "text-pb-text-muted",
  none: "text-pb-text-muted",
};

export function statusDeltaClass(status: KpiStatus): string {
  return STATUS_DELTA_CLASS[status];
}
